import * as types from "../constants/actionConstants";

const initialState = [];

function groupTemplateListReducer(state = initialState, action) {
    switch (action.type) {
        case types.GROUP_TEMPLATE_LIST_GET_SUCCESS:
        case types.GROUP_TEMPLATE_LIST_CURRENT_GET_SUCCESS:
            return action.list;

        default:
            return state;
    }
}

export default groupTemplateListReducer;
